
export interface AppConfig {
    MAIN_BASE_URL: string;
    REACT_APP_GOOGLE_MAPS_API_KEY: string;
    APP_VERSION: string
    MAIN_THIRD_PARTY_BASE_URL?: string;
    dev?: string;
    Uat?: string;
    microdev?: string;
    microUat?: string;
    adcs?: string;
    microAdcs?: string;
}
export const baseUrl: AppConfig = {
    MAIN_BASE_URL: process.env.REACT_APP_AZURE_API_BASEURL || "",
    REACT_APP_GOOGLE_MAPS_API_KEY: "AIzaSyDRamKOTuCnMPw7b6BP2qdRWfuSJnIFpfI",
    // APP_VERSION: "SS.W7.02.22.1",
    APP_VERSION: "SS.W8.09.17.1",
};
